// Please align HEX code with variables.scss

export const white = "#fff"
export const primaryColor = "#385680" 